import { render, staticRenderFns } from "./bombsSetup.vue?vue&type=template&id=3e7b91a8&scoped=true&"
import script from "./bombsSetup.vue?vue&type=script&lang=js&"
export * from "./bombsSetup.vue?vue&type=script&lang=js&"
import style0 from "./bombsSetup.vue?vue&type=style&index=0&id=3e7b91a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7b91a8",
  null
  
)

export default component.exports